module.exports = __webpack_public_path__ + "img/bg28.7e3ce90f.jpg";